<template>
  <div>

    <ul>
      <li>
        <p>1. Клиент должен установить приложение.</p>
        <img src="/img/trueConf/a2.png" alt="" style="width: 500px">
      </li>
      <li>2. Все остальные инструкции, клиент получит от Агента</li>
<!--      <li>-->
<!--        <p>2. После установки приложения запустить его.<br/>-->
<!--          Ввести номер заявки <b>({{getDemandIdMsg}})</b> и номер своего паспорта</p>-->
<!--        <img src="/img/trueConf/a1.png" alt="">-->
<!--      </li>-->
    </ul>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  export default {
    name: "android",
    computed:{
      ...mapGetters(['getDemandIdMsg']),
    }
  }
</script>

<style scoped>

</style>
